import { ChartSpecificColumnType, ColumnType, } from '@thoughtspot/ts-chart-sdk';
import { AnswerColumnEffectiveType, } from '../../../types/prism';
export const ColumnTypeToEffectiveTypeMap = {
    [ColumnType.UNKNOWN]: AnswerColumnEffectiveType.Unknown,
    [ColumnType.MEASURE]: AnswerColumnEffectiveType.Measure,
    [ColumnType.ATTRIBUTE]: AnswerColumnEffectiveType.Attribute,
    [ColumnType.VIRTUAL]: AnswerColumnEffectiveType.Unknown,
};
export const ChartSpecificColumnTypeToColumnTypeMap = {
    [ChartSpecificColumnType.UNKNOWN]: AnswerColumnEffectiveType.Unknown,
    [ChartSpecificColumnType.MEASURE_NAMES]: AnswerColumnEffectiveType.Attribute,
    [ChartSpecificColumnType.MEASURE_VALUES]: AnswerColumnEffectiveType.Measure,
};
//# sourceMappingURL=types.js.map